import Reveal from "./Reveal";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useBooking } from "../context/BookingContext";

const details = [
  { icon: MapPin, label: "The Studio", value: "4220 Steeles Avenue West\nWoodbridge, ON, Canada" },
  { icon: Phone, label: "Reservations", value: "(905) 851-9106" },
  { icon: Mail, label: "Enquiries", value: "atelier@picasostudios.ca" },
  { icon: Clock, label: "Hours", value: "Open today\n09:00 a.m. – 05:00 p.m." },
];

export const Contact = () => {
  const { openBooking } = useBooking();

  return (
    <section
      id="scalp-lounge"
      data-testid="contact-section"
      className="py-32 md:py-40 max-w-7xl mx-auto px-6 md:px-12"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <Reveal>
          <p className="text-umber text-xs uppercase tracking-[0.3em] mb-5">Visit Us</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.05] text-obsidian">
            Begin your<br />consultation
          </h2>
          <p className="mt-6 text-obsidian/70 font-light text-sm md:text-base leading-[1.6] max-w-md">
            Step into our Vaughan atelier — a quiet, light-filled space devoted entirely to
            your transformation. Reserve a private consultation with one of our master artists.
          </p>
          <button
            data-testid="contact-book-button"
            onClick={() => openBooking()}
            className="mt-10 inline-flex items-center gap-3 bg-obsidian text-[#FDFBF7] px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-umber transition-colors duration-500"
          >
            Secure a Consultation →
          </button>
        </Reveal>

        <Reveal delay={0.12} className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#E8E2D2] border border-[#E8E2D2]">
          {details.map((d) => (
            <div
              key={d.label}
              className="bg-[#FDFBF7] p-8 md:p-10"
              data-testid={`contact-${d.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <d.icon size={20} className="text-champagne mb-5" strokeWidth={1.4} />
              <p className="text-xs uppercase tracking-[0.2em] text-obsidian/50 mb-3">{d.label}</p>
              <p className="font-light text-sm text-obsidian whitespace-pre-line leading-[1.6]">
                {d.value}
              </p>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
